import Flickity from 'flickity';
import "flickity/css/flickity.css";
import "@css/components/flickity-overrides.scss";

import {
	qsa,
	docReady
} from "@/libs/helpers";


const getTarget = (image) => {
	let src = image.getAttribute('data-gallery');
	if (!src && image.tagName === 'IMG') {
		src = image.src;
	}
	return src || false;
};

docReady(() => {

	qsa('[data-hero-carousel]', list => {

		if (list.querySelectorAll('[data-slide]').length <= 1) {
			return;
		}

		const flkty = new Flickity(list, {
			cellSelector: '[data-slide]',
			prevNextButtons: true,
			pageDots: false,
			adaptiveHeight: false,
			wrapAround: true,
			setGallerySize: false,
			arrowShape: {
				x0: 10,
				x1: 60, y1: 50,
				x2: 70, y2: 40,
				x3: 30
			}
		});

		const zoomButton = list.querySelector('[data-trigger-zoom]');

		if (zoomButton) {
			const checkTrigger = () => {
				const img = flkty.selectedCell.element.querySelector('[data-gallery]');
				if (img) {
					const src = getTarget(img);
					if (src) zoomButton.setAttribute('data-trigger-zoom', src);
				}
			};

			checkTrigger();
			flkty.on('select', checkTrigger);
		}
	});

});
